module.exports = (str) => `'${str}'`
